var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"login-page-route-container"},[_c('LoginContent',{attrs:{"isRoute":true,"hideBusinessTab":true}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }